import { render, staticRenderFns } from "./Slideshows.vue?vue&type=template&id=f94d4c34&"
import script from "./Slideshows.vue?vue&type=script&lang=js&"
export * from "./Slideshows.vue?vue&type=script&lang=js&"
import style0 from "./Slideshows.vue?vue&type=style&index=0&id=f94d4c34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports